import { Dropdown, DropdownItem } from '@platform/components';
import { RepProjectPanel } from 'lib/client/src/platformapi.schemas';
import { DeleteProjectModalContext } from '../Modals/DeleteProjectModal';
import { useContext } from 'react';

interface ProjectActionDropdownProps {
  panelData: RepProjectPanel;
}

export const ProjectActionDropdown = (props: ProjectActionDropdownProps) => {
  const { panelData } = { ...props };
  const { openDeleteProjectModal } = useContext(DeleteProjectModalContext);

  const { project } = { ...panelData };
  const { id: projectId, publishingStage } = { ...project };

  const isProjectEditable = publishingStage === 'unpublished' || publishingStage === 'draft';
  const isProjectUnderReview =
    publishingStage === 'review' || publishingStage === 'revision_requested';

  const projectIsDeletable =
    !panelData.actionRequired.length &&
    !panelData.inProgress.length &&
    !panelData.inactive.length &&
    (isProjectEditable || isProjectUnderReview);

  if (!projectId) {
    return null;
  }

  return (
    <Dropdown type={'icon'} ariaLabel='Dropdown button' iconName='dots-vertical'>
      {!isProjectEditable && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/dashboard/organization/request?oppId=${projectId}&actionType=clone`}
        >
          Clone
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/dashboard/organization/request?oppId=${projectId}`}
        >
          Edit
        </DropdownItem>
      )}
      {!isProjectEditable && !panelData.completed && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/setup/opportunity/${projectId}/unpublish`}
        >
          Unpublish
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/setup/opportunity/${projectId}/publish`}
        >
          Publish
        </DropdownItem>
      )}
      {projectIsDeletable && (
        <DropdownItem
          onAction={() => {
            openDeleteProjectModal(projectId);
          }}
        >
          Delete
        </DropdownItem>
      )}
    </Dropdown>
  );
};
